<template lang="pug">
    #verifyArea(
        ref="verifyArea"
    )
        canvas#verifyCanvas(
            width="80",
            height="48",
            :class={ 'd-none': showVerifyCanvas },
            @click="changeVerifyCodeHandler",
            ref="canvas"
        )
            img(
                :src="verifyCanvasSrc"
            )
        input#varifyAnswer(
            type="hidden",
            v-model="varifyAnswer"
        )
    </div>
</template>

<script>
export default {
  name: 'VerifyComponent',
  data() {
    return {
      canvas: null,
      showVerifyCanvas: true,
      verifyNum: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz',
      varifyAnswer: null,
      verifyCanvasSrc: null
    };
  },
  mounted() {
    this.drawCode();
  },
  methods: {
    drawCode() {
      const vm = this;
      const canvas = document.getElementById('verifyCanvas');
      const context = canvas.getContext('2d');
      const nums = vm.verifyNum.split('');
      vm.canvas = canvas;
      context.fillStyle = '#000';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = 'rgb(137, 137, 137)';
      context.font = '25px Arial';
      const rand = new Array();
      const x = new Array();
      const y = new Array();
      for (let i = 0; i < 4; i++) {
        rand[i] = nums[Math.floor(Math.random() * nums.length)];
        x[i] = i * 16 + 10;
        y[i] = Math.random() * 20 + 20;
        context.fillText(rand[i], x[i], y[i]);
      }
      const answer = rand.join('');
      vm.varifyAnswer = answer;

      //   for (let i = 0; i < 3; i++) {
      //     vm.drawline(canvas, context);
      //   }

      //   for (let i = 0; i < 30; i++) {
      //     vm.drawDot(canvas, context);
      //   }
      vm.showVerifyCanvas = false;
      vm.verifyCanvasSrc = canvas.toDataURL('image/png');
    },
    drawline(canvas, context) {
      context.moveTo(Math.floor(Math.random() * canvas.width), Math.floor(Math.random() * canvas.height));
      context.lineTo(Math.floor(Math.random() * canvas.width), Math.floor(Math.random() * canvas.height));
      context.lineWidth = 0.5;
      context.strokeStyle = 'rgba(100,100,100,1)';
      context.stroke();
    },
    drawDot(canvas, context) {
      const px = Math.floor(Math.random() * canvas.width);
      const py = Math.floor(Math.random() * canvas.height);
      context.moveTo(px, py);
      context.lineTo(px + 1, py + 1);
      context.lineWidth = 0.2;
      context.stroke();
    },
    changeVerifyCodeHandler() {
      const vm = this;
      const context = vm.$refs.canvas.getContext('2d');
      context.clearRect(0, 0, vm.$refs.canvas.width, vm.$refs.canvas.height);
      vm.drawCode();
    }
  }
};
</script>

<style>

</style>
